import { Pipe, PipeTransform } from '@angular/core';
import { DateTime as LuxonDateTime } from 'luxon';

@Pipe({
    name: 'ttime',
    standalone: false
})
export class TimePipe implements PipeTransform {

  transform(value: string | LuxonDateTime): string {
    if (value) {
      const dateTime = typeof value === 'string' 
        ? (value.length > 5 
          ? LuxonDateTime.fromFormat(value, 'HH:mm:ss')
          : LuxonDateTime.fromFormat(value, 'HH:mm'))
        : value;
      let formattedTime = dateTime.toFormat('h:mma');
      formattedTime = this.translateAMPM(formattedTime);
      return formattedTime;
    }
  }

  translateAMPM(formattedTime: string) {
    const language = localStorage.getItem('language') || 'en';
    Object.keys(translations).forEach(key => {
      if (translations[key][language] && formattedTime.includes(key)) {
        formattedTime = formattedTime.replace(key, translations[key][language]);
      }
    });
    return formattedTime;
  }
}

const translations = {
  'AM': {
    en: 'am',
    es: 'am',
    ar: 'ص',
    fr: 'am',
    pt: 'am',
    de: 'am',
    ja: 'am',
    it: 'am'
  },
  'PM': {
    en: 'pm',
    es: 'pm',
    ar: 'م',
    fr: 'pm',
    pt: 'pm',
    de: 'pm',
    ja: 'pm',
    it: 'pm'
  }
};

